import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=b173d036&scoped=true"
import script from "./PlanItem.vue?vue&type=script&lang=js"
export * from "./PlanItem.vue?vue&type=script&lang=js"
import style0 from "./PlanItem.vue?vue&type=style&index=0&id=b173d036&prod&lang=scss&scoped=true"
import style1 from "./PlanItem.vue?vue&type=style&index=1&id=b173d036&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b173d036",
  null
  
)

export default component.exports